import { apiClient } from '@/api'

export default {
  namespaced: true,
  state: () => ({
    services:[],
    groups:[],
    total:0,
  }),
  mutations: {
    SET_SERVICES(state, items) {
      state.services = items
    },
    SET_GROUPS(state, items) {
      state.groups = items
    },
    SET_TOTAL(state, items) {
      state.total = items
    }
  },
  actions: {
    async fetchServices({ commit }, data) {
      const res = await apiClient('services.get', data)
      commit('SET_SERVICES', res.list)
      commit('SET_TOTAL', res.total)
    },
    async saveService({ commit }, scheduleData) {
      const res = await apiClient('services.create', scheduleData)
      commit('SET_SERVICES', res.list)
      commit('SET_TOTAL', res.total)
    },
    async updateService({ commit }, scheduleData) {
      const res = await apiClient('services.update', scheduleData)
      commit('SET_SERVICES', res.list)
      commit('SET_TOTAL', res.total)
    },
    async deleteService({ commit }, id) {
      const res = await apiClient('services.delete', { id })
      commit('SET_SERVICES', res.list)
      commit('SET_TOTAL', res.total)
    },
    async fetchGroups({ commit }) {
      const res = await apiClient('services_groups.get')
      commit('SET_GROUPS', res.list)
    },
    async saveGroup({ commit }, scheduleData) {
      const res = await apiClient('services_groups.create', scheduleData)
      commit('SET_GROUPS', res.list)
    },
    async updateGroup({ commit }, scheduleData) {
      const res = await apiClient('services_groups.update', scheduleData)
      commit('SET_GROUPS', res.list)
    },
    async deleteGroup({ commit }, id) {
      const res = await apiClient('services_groups.delete', { id })
      commit('SET_GROUPS', res.list)
    },
  }
}